import * as React from 'react';
import './Camera.css'
import Webcam from "react-webcam";

const ReactCamera = ({ photoTakenCallback }) => {

    const webcamRef = React.useRef(null);
    const height = window.innerHeight;
    const width = window.innerWidth;
    const isLandscape = height <= width;
    const ratio = isLandscape ? width / height : height / width;

    const capture = React.useCallback(() => {
        //@ts-ignore
        const imageSrc = webcamRef.current.getScreenshot();
        photoTakenCallback(imageSrc);
    }, [webcamRef, photoTakenCallback]);

    const [, setDimensions] = React.useState({
        height: window.innerHeight,
        width: window.innerWidth
    })

    React.useEffect(() => {
        function handleResize() {
            setDimensions({
                height: window.innerHeight,
                width: window.innerWidth
            })
        }

        window.addEventListener('resize', handleResize)
    })

    return (
        <>
            {<>
                <Webcam
                    height={height}
                    width={width}
                    audio={false}
                    ref={webcamRef}
                    videoConstraints={{ aspectRatio: ratio, facingMode: { exact: "environment" } }}
                    screenshotFormat="image/jpeg"
                />
                <div onClick={capture} id="container-circles">
                    <div id="outer-circle">
                        <div id="inner-circle">
                        </div>
                    </div>
                </div>
            </>
            }
        </>
    );

    //return (
    //    <>
    //        {
    //            (photoSubmitted || photoAccepted)
    //                ? <ImagePreview photo={photoData} isFullscreen={false} />
    //                : <>
    //                    <Webcam
    //                        audio={false}
    //                        ref={webcamRef}
    //                        screenshotFormat="image/jpeg"
    //                    />
    //                    <div onClick={capture} id="container-circles">
    //                        <div id="outer-circle">
    //                            <div id="inner-circle">
    //                            </div>
    //                        </div>
    //                    </div>
    //                </>
    //        }
    //    </>
    //);
};

export default (ReactCamera);